import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';
export default function LandingPage() {
    const { t } = useTranslation();
    return (
        <section className="landingHome relative">
            <div className="container h-full flex justify-between gap-[40px]">
                <div className="w-100 w-[48%] flex flex-col justify-center gap-[20px]">
                    <div>
                        <div className="text-[40px] font-bold leading-[1.1]">{t("Empower Your Learning Journey with")}</div>
                        <div className="flex flex-col w-fit">
                            <div className="w-fit text-[40px] text-[#09778E] font-bold">{t("Be Academix")}</div>
                            <img className="w-[67%] h-auto" src={require("../../assets/icons/line-title.svg").default} alt="" />
                        </div>
                    </div>
                    <p>{t("Unlock knowledge, enhance skills, and achieve academic success with our expert-led courses")}</p>
                    <Link to={""} className="btn">
                        <span>{t("Explore Courses")}</span>
                        <div>
                            <img className="w-[25px] h-[25px]" src={require("../../assets/icons/arrow-button.svg").default} alt="" />
                        </div>
                    </Link>
                </div>

                {/* Right Side - Image and Statistics */}
                <div className="d-none w-[48%] relative flex">
                    <div>
                        <img className="w-full h-full" src={require("../../assets/images/landingHomeImage.svg").default} alt="" />
                    </div>
                </div>
            </div>
        </section>
    );
}
